<template>
  <div>
    <van-popup v-model="showStart" round position="bottom">
      <van-datetime-picker
        type='date'
        v-model="currentStartDate"
        title="选择开始日期"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="confirmStartDate"
        @cancel="cancelStartDate"
      />
    </van-popup>

    <van-popup v-model="showEnd" round position="bottom">
      <van-datetime-picker
        type='date'
        v-model="currentEndDate"
        title="选择结束日期"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="confirmEndDate"
        @cancel="cancelEndDate"
      />
    </van-popup>
  </div>
</template>

<script>
import day from 'dayjs'

export default {
  name: 'StartEndDatePicker',
  emits: ['confirm'],
  data() {
    return {
      minDate: new Date(1950, 0, 1),
      maxDate: new Date(2050, 11, 31),
      startTime: "",
      endTime: "",
      showStart: false,
      currentStartDate: "",
      showEnd: false,
      currentEndDate: "",

    }
  },
  methods: {
    cancelStartDate() {
      this.showStart = false
    },
    confirmStartDate(date) {
      this.startTime = day(date).format("YYYY-MM-DD");
      this.showStart = false
      this.showEnd = true
    },
    cancelEndDate() {
      this.startTime = "";
      this.showEnd = false;
    },
    confirmEndDate(date) {
      this.endTime = day(date).format("YYYY-MM-DD");
      this.showEnd = false

      this.$emit('confirm', this.startTime, this.endTime)
    },
    open() {
      this.currentStartDate = new Date();
      this.currentEndDate = new Date();
      this.showStart = true

    }
  }
}

</script>

<style scoped></style>
